import { render, staticRenderFns } from "./UnitTraffic.vue?vue&type=template&id=13c60c94&scoped=true&"
import script from "./UnitTraffic.vue?vue&type=script&lang=js&"
export * from "./UnitTraffic.vue?vue&type=script&lang=js&"
import style0 from "./UnitTraffic.vue?vue&type=style&index=0&id=13c60c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c60c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VTextarea})
